import { render, staticRenderFns } from "./ComplianceSummary.vue?vue&type=template&id=0a095dd2&"
import script from "./ComplianceSummary.vue?vue&type=script&lang=js&"
export * from "./ComplianceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports